import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ISecret } from '@mode/notebooks/contract';

@Component({
  selector: 'mode-secret-row-button',
  templateUrl: './secret-row-button.component.html',
  styleUrls: ['./secret-row-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecretRowButtonComponent {
  @Input() secret!: ISecret;
  @Output() editSecret = new EventEmitter<ISecret>();
  @Output() deleteSecret = new EventEmitter<ISecret>();
  @Output() handleDialogOpen = new EventEmitter<{ token: string; active: boolean }>();
  isDialogOpen = false;
  positions = [
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];

  edit(): void {
    this.isDialogOpen = false;
    this.editSecret.emit(this.secret);
  }
  delete(): void {
    this.isDialogOpen = false;
    this.deleteSecret.emit(this.secret);
  }
  handleDialog(): void {
    this.isDialogOpen = !this.isDialogOpen;
    this.handleDialogOpen.emit({
      token: this.secret.token,
      active: this.isDialogOpen,
    });
  }
}
